import React from "react";
import ProductDetailsModule from "./Module";
import { Box, styled, Typography } from "@material-ui/core";
import { formatMultilinesText } from "../../../../../helpers/markdown";

const List = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  "& > div:first-child": {
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px"
  },
  "& > div:last-child": {
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px"
  }
}));

type Props = {
  data: Queries.DatoCmsCModulePvTechSpec & {
    description?: string;
  };
};

const ProductDetailsModuleTechSpec = ({ data }: Props) => {
  return (
    <ProductDetailsModule title={data.title}>
      {data.description && (
        <Box mb={3}>
          <Typography
            dangerouslySetInnerHTML={{
              __html: formatMultilinesText(data.description)
            }}
          />
        </Box>
      )}

      {data.specs && data.specs.length > 0 && (
        <List>
          {data.specs.map(spec => (
            <Box
              key={spec.title}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              bgcolor="grey.100"
              paddingX={{ xs: 2 }}
              paddingY={{ xs: 1 }}
              mb="1px"
            >
              <Box minWidth={{ xs: "none", md: "30%" }} marginRight={2}>
                <Typography className="compact" color="textSecondary">
                  {spec.title}
                </Typography>
              </Box>
              <Box flex={1}>{spec.value}</Box>
            </Box>
          ))}
        </List>
      )}
    </ProductDetailsModule>
  );
};

export default ProductDetailsModuleTechSpec;
